<div class="cards-page">
  <h1 class="bold-24">{{ 'cardsAdminTitle' | transloco }}</h1>
  <div class="tabs-container">
    <button class="tab-button" [class.active]="currentTab() === 'runs'" (click)="selectTab('runs')">{{ 'cardsAdminRuns' | transloco }}</button>
    <button class="tab-button" [class.active]="currentTab() === 'studio'" (click)="selectTab('studio')">{{ 'cardsAdminStudio' | transloco }}</button>
    <button class="tab-button" [class.active]="currentTab() === 'spawns'" (click)="selectTab('spawns')">{{ 'cardsAdminSpawns' | transloco }}</button>
    <button class="tab-button" [class.active]="currentTab() === 'calendar'" (click)="selectTab('calendar')">{{ 'cardsAdminCalendar' | transloco }}</button>
    <button class="tab-button" [class.active]="currentTab() === 'seeds'" (click)="selectTab('seeds')">{{ 'cardsAdminSeeds' | transloco }}</button>
    <button class="tab-button" [class.active]="currentTab() === 'battles'" (click)="selectTab('battles')">{{ 'cardsAdminBattles' | transloco }}</button>
    <button class="tab-button" [class.active]="currentTab() === 'submissions'" (click)="selectTab('submissions')">{{ 'cardsAdminSubmissions' | transloco }}</button>
    <button class="tab-button" [class.active]="currentTab() === 'drops'" (click)="selectTab('drops')">{{ 'cardsAdminDrops' | transloco }}</button>
    <button class="tab-button" [class.active]="currentTab() === 'rewards'" (click)="selectTab('rewards')">{{ 'cardsAdminRewards' | transloco }}</button>
    <button class="tab-button" [class.active]="currentTab() === 'catalog'" (click)="selectTab('catalog')">{{ 'cardsAdminCatalog' | transloco }}</button>
  </div>
  @switch (currentTab()) {
    @case ('runs') { <app-cards-runs-tab /> }
    @case ('studio') { <app-cards-studio-tab /> }
    @case ('spawns') { <app-cards-spawns-tab /> }
    @case ('calendar') { <app-cards-calendar-tab /> }
    @case ('seeds') { <app-cards-seeds-tab /> }
    @case ('battles') { <app-cards-battles-tab /> }
    @case ('submissions') { <app-cards-submissions-tab /> }
    @case ('drops') { <app-cards-drops-tab /> }
    @case ('rewards') { <app-cards-rewards-tab /> }
    @case ('catalog') { <app-cards-catalog-tab /> }
  }
</div>
